var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { memo, forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { useObserver } from './hooks';
export function observer(baseComponent, options) {
    var realOptions = __assign({ forwardRef: false }, options);
    var wrappedComponent = realOptions.forwardRef
        ? forwardRef(function (props, ref) {
            return useObserver(function () {
                return baseComponent(__assign(__assign({}, props), ref));
            }, realOptions);
        })
        : function (props) {
            return useObserver(function () { return baseComponent(props); }, realOptions);
        };
    var memoComponent = memo(wrappedComponent);
    hoistNonReactStatics(memoComponent, baseComponent);
    if (realOptions.displayName) {
        memoComponent.displayName = realOptions.displayName;
    }
    return memoComponent;
}
